import { render, staticRenderFns } from "./UpdateInfoShow.vue?vue&type=template&id=2c709fc1&"
import script from "./UpdateInfoShow.vue?vue&type=script&lang=js&"
export * from "./UpdateInfoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports